import { parseGeminiMessage } from "../utilities/parseGeminiMessage"

export const ChatMessage = ({index, message}) => {
    return (
        <div key={`message ${index}`} className={`chat-message ${message.role}`}>
            <p className="chat-message-content">{parseGeminiMessage(message.parts.find(part => part.text).text)}</p>
        </div>
    )
} 